<template>
    <v-container grid-list-md fluid class="pa-0" style="overflow: hidden">
        <v-card class="default_card_wm mb-0 pb-0 elevation-0" :style="bookletContentCardStyle">
            <v-row no-gutters>
                <v-col class="d-flex pr-1" cols="6" v-if="!previewMode">
                    <v-row no-gutters class="pa-2">
                        <v-col cols="12">
                            <v-text-field-filled
                                v-model="search"
                                label="Rechercher"
                                single-line
                                hide-details
                                class="pb-1 px-1"
                                append-inner-icon="$search"
                                density="compact"
                                clearable
                                @click:clear="search = ''"
                            />
                        </v-col>
                        <v-col cols="4">
                            <v-tabs v-model="accountingFormCategory" direction="vertical">
                                <!-- style="background-color: transparent !important" -->
                                <!-- width="500px" -->
                                <v-tab
                                    v-for="category in accountingFormCategories"
                                    :key="category.category"
                                    :text="category.name"
                                    :value="category.category"
                                >
                                    <strong>{{ category.name }}</strong>
                                </v-tab>
                            </v-tabs>
                        </v-col>
                        <v-col
                            cols="8"
                            class="my-1 pl-2"
                            style="height: calc(100vh - 300px); overflow-y: auto"
                        >
                            <draggable
                                class="list-group"
                                :list="accountingFormsPages"
                                :group="{ name: 'a', pull: 'clone', put: false }"
                                :options="{ disabled: readonly }"
                                itemKey="id"
                                draggable=".item"
                            >
                                <template #item="{ element: page, index: pi }">
                                    <v-list-item
                                        :class="getAccountingFormClass(page.disabled)"
                                        v-if="
                                            page.category === accountingFormCategory &&
                                            searchedPages.includes(page)
                                        "
                                        :key="page.cerfa"
                                        :disabled="readonly || page.disabled"
                                        :border="true"
                                        rounded
                                        @click="addIntoBooklet(page, pi)"
                                    >
                                        <!-- <template v-slot:append>
                                            <v-icon
                                                dense
                                                 size=“x-small”
                                                disabled
                                            >$oss-eye</v-icon>
                                        </template> -->
                                        <template v-slot:append>
                                            <v-row>
                                                <v-col class="d-flex align-center">
                                                    <v-btn
                                                        rounded
                                                        size="x-small"
                                                        elevation="0"
                                                        :style="
                                                            readonly
                                                                ? ''
                                                                : 'pointer-events: initial !important;'
                                                        "
                                                        :disabled="readonly"
                                                        @click.stop="
                                                            readonly
                                                                ? null
                                                                : addDifferentFormat(page, pi)
                                                        "
                                                        v-if="
                                                            page.format &&
                                                            !page.bothFormatUsed &&
                                                            isInBooklet(page)
                                                        "
                                                        >+ {{ newFormat(page) }}</v-btn
                                                    >
                                                    <v-icon dense size="x-small" v-else
                                                        >$add</v-icon
                                                    >
                                                </v-col>

                                                <v-col
                                                    v-if="
                                                        accountingFormCategory ===
                                                        'personalisedDocument'
                                                    "
                                                >
                                                    <v-menu location="start">
                                                        <template v-slot:activator="{ props }">
                                                            <v-btn-icon
                                                                icon="$dots_vertical"
                                                                v-bind="props"
                                                                dense
                                                                size="small"
                                                                :style="
                                                                    readonly
                                                                        ? ''
                                                                        : 'pointer-events: initial !important;'
                                                                "
                                                                :disabled="readonly"
                                                            />
                                                        </template>
                                                        <v-list density="compact">
                                                            <v-list-item
                                                                @click.stop="
                                                                    persoDocToUpdate = page.cerfa
                                                                "
                                                            >
                                                                <template #append>
                                                                    <v-icon size="x-small"
                                                                        >$oss-edit</v-icon
                                                                    >
                                                                </template>
                                                                <v-list-item-title
                                                                    >Changer le
                                                                    titre</v-list-item-title
                                                                ></v-list-item
                                                            >
                                                            <v-list-item
                                                                @click.stop="
                                                                    persoDocToDelete = page.cerfa
                                                                "
                                                            >
                                                                <template #append>
                                                                    <v-icon size="x-small"
                                                                        >$oss-trash</v-icon
                                                                    >
                                                                </template>
                                                                <v-list-item-title
                                                                    >Supprimer</v-list-item-title
                                                                ></v-list-item
                                                            >
                                                        </v-list>
                                                    </v-menu>
                                                </v-col>
                                            </v-row>
                                        </template>
                                        <span>{{ displayTitle(page) }}</span
                                        ><span
                                            v-if="page.printableTitle"
                                            size="x-small"
                                            style="font-style: italic"
                                        >
                                            &emsp;{{ page.printableTitle }}
                                        </span>
                                    </v-list-item>
                                </template>
                            </draggable>
                            <template v-if="accountingFormCategory === 'personalisedDocument'">
                                <v-list-item
                                    :class="getAccountingFormClassForUploadFile()"
                                    :disabled="readonly"
                                    @click="openUploadFileDialog()"
                                >
                                    <v-btn-icon icon="$fa-upload" />
                                </v-list-item>
                            </template>
                        </v-col>
                    </v-row>
                </v-col>
                <v-col class="px-1 pb-1" :cols="previewMode ? '12' : '6'">
                    <!-- IN PREVIEW_MODE WE ONLY SEE THIS -->
                    <v-row no-gutters class="pa-2" v-if="booklet">
                        <v-col cols="12">
                            <v-row no-gutters class="mb-0">
                                <v-col
                                    :cols="previewMode ? 10 : 12"
                                    class="title d-flex align-center justify-center"
                                >
                                    <h4>Détail</h4>
                                </v-col>
                                <v-col cols="2" class="justify-end" v-if="previewMode">
                                    <v-btn
                                        fab
                                        size="small"
                                        elevation="0"
                                        @click="openCustomDialog"
                                        icon="$oss-edit"
                                    >
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col
                            cols="12"
                            class="my-3 d-flex align-start"
                            :style="heightOfBookletView"
                        >
                            <draggable
                                class="list-group py-6"
                                :id="booklet.id"
                                :list="booklet.pages"
                                :group="{ name: 'a' }"
                                draggable=".item"
                                itemKey="id2"
                                handle=".handle"
                                @change="updateBooklet($event)"
                                :options="{ disabled: readonly || previewMode }"
                            >
                                <template #item="{ element: page, index: pi }">
                                    <v-list-item
                                        class="list-group-item oss-list-item item mt-1"
                                        :key="page.cerfa + '_' + page.format + '_' + pi"
                                        style="cursor: default"
                                        :border="true"
                                        rounded
                                    >
                                        <template v-slot:prepend>
                                            <v-icon
                                                icon="$fa-align-justify"
                                                size="x-small"
                                                :disabled="!isDraggable(page)"
                                                :class="isDraggable(page)"
                                                v-if="!previewMode"
                                            />
                                        </template>
                                        <div>
                                            <span>{{ displayTitle(page) }}</span>
                                            <span
                                                v-if="page.format"
                                                style="font-style: italic; font-size: x-small"
                                            >
                                                &emsp;{{ displayPageFormat(page.format) }}
                                            </span>
                                            <!-- <div v-if="page.printableTitle !== undefined"> -->
                                            <v-text-field-filled
                                                v-model="page.printableTitle"
                                                hide-details
                                                class="pl-2 separationPageTextField"
                                                :disabled="readonly || previewMode"
                                                :style="
                                                    readonly || previewMode
                                                        ? 'pointer-events: none !important;'
                                                        : ''
                                                "
                                                v-if="page.printableTitle !== undefined"
                                                density="compact"
                                            />
                                            <!-- </div> -->
                                        </div>
                                        <template v-slot:append>
                                            <v-menu absolute offset-y v-if="page.format">
                                                <template v-slot:activator="{ props }">
                                                    <v-icon
                                                        v-bind="props"
                                                        dense
                                                        :disabled="readonly"
                                                        v-if="!previewMode"
                                                        size="x-small"
                                                        >$oss-edit</v-icon
                                                    >
                                                </template>
                                                <v-list>
                                                    <v-list-item lines="one">
                                                        <!-- <v-list-item-title
                                                            >Format saisie</v-list-item-title
                                                        > -->
                                                        Format saisie
                                                        <!-- <template> -->
                                                        <v-switch
                                                            v-model="page.format"
                                                            false-value="saisie"
                                                            true-value="cerfa"
                                                            @change="changeFormat(page)"
                                                            size="small"
                                                        />
                                                        <!-- </template> -->
                                                        Format CERFA
                                                        <!-- <v-list-item-title
                                                            >Format CERFA</v-list-item-title
                                                        > -->
                                                    </v-list-item>
                                                </v-list>
                                            </v-menu>
                                            <v-icon
                                                class="ml-2"
                                                :disabled="readonly"
                                                v-if="!previewMode"
                                                @click.stop="removeFromBooklet(page, pi)"
                                                size="x-small"
                                                >$oss-trash</v-icon
                                            >
                                        </template>
                                    </v-list-item>
                                </template>
                            </draggable>
                        </v-col>
                        <v-col
                            cols="12"
                            class="d-flex justify-center"
                            v-if="booklet.pages && booklet.pages.length > 7"
                            size="small"
                        >
                            {{ booklet.pages.length }} pages
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-card>
        <oss-dialog
            v-model="customBookletTemplateDialog"
            title="Modifiez votre plaquette personnalisée"
        >
            <div>
                <BookletContent
                    :booklet="duplicatedBooklet"
                    :initialBooklet="booklet"
                    :bundleId="bookletTemplateId"
                    :bundleType="bundleType"
                    @booklet-changed="onDuplicatedBookletChanged"
                ></BookletContent>
            </div>
        </oss-dialog>
        <oss-dialog
            v-model="personalisedDocumentsDialog"
            title="Importer un document personnalisé"
            :previous-display="false"
            :actions="actions"
            v-if="personalisedDocumentsDialog"
            width="800px"
        >
            <UploadDocuments
                :companyId="accountingCompanyId"
                :documentType="'BOOKLET_TEMPLATE'"
                :multiple="false"
                :freeTag="false"
                :inExtensions="['docx', 'pdf']"
                :actions="actions"
                @file="addPersonalisedDoc($event)"
            />
        </oss-dialog>

        <oss-dialog
            v-model="persoDocToUpdate"
            title="Modifier le titre"
            :previous-display="false"
            :validLoading="newNameLoading"
            :validDisabled="!newName"
            @valid="updatePersonalisedDocName(persoDocToUpdate, newName)"
            v-if="persoDocToUpdate"
            width="800px"
        >
            <v-text-field-filled v-model="newName" label="Nouveau nom" outlined density="compact" />
        </oss-dialog>
        <oss-dialog
            v-model="persoDocToDelete"
            title="Supprimer ce document"
            :previous-display="false"
            :validLoading="deleteLoading"
            @valid="deletePersonalisedDoc()"
            v-if="persoDocToDelete"
            width="800px"
        >
            <h4 class="text-center">&#xca;tes-vous sûr(e) de vouloir supprimer ce document ?</h4>
        </oss-dialog>
    </v-container>
</template>

<script lang="ts">
import FORM_BNC_2024 from "../../../../backend/src/common/bundle/formList/2024/Form_BNC.json";
import FORM_RSS_2024 from "../../../../backend/src/common/bundle/formList/2024/Form_RSS.json";
import FORM_RSP_2024 from "../../../../backend/src/common/bundle/formList/2024/Form_RSP.json";
import FORM_RNS_2024 from "../../../../backend/src/common/bundle/formList/2024/Form_RNS.json";
import FORM_RNP_2024 from "../../../../backend/src/common/bundle/formList/2024/Form_RNP.json";
import FORM_SCI_2024 from "../../../../backend/src/common/bundle/formList/2024/Form_SCI.json";

import FORM_BNC_2025 from "../../../../backend/src/common/bundle/formList/2025/Form_BNC.json";
import FORM_RSS_2025 from "../../../../backend/src/common/bundle/formList/2025/Form_RSS.json";
import FORM_RSP_2025 from "../../../../backend/src/common/bundle/formList/2025/Form_RSP.json";
import FORM_RNS_2025 from "../../../../backend/src/common/bundle/formList/2025/Form_RNS.json";
import FORM_RNP_2025 from "../../../../backend/src/common/bundle/formList/2025/Form_RNP.json";
import FORM_SCI_2025 from "../../../../backend/src/common/bundle/formList/2025/Form_SCI.json";
import FORM_RNA_2025 from "../../../../backend/src/common/bundle/formList/2025/Form_RNA.json";
import FORM_RSA_2025 from "../../../../backend/src/common/bundle/formList/2025/Form_RSA.json";

import BOOKLET_ANNEXES from "../../../../backend/src/common/bundle/formList/Form_ANNEXES.json";

import { DialogAction } from "../../services/dialogAction";
import { User } from "../../store/store";
import draggable from "vuedraggable";
import UploadDocuments from "../document/UploadDocuments.vue";
import DELETE_PERSONALISED_FILE from "../../graphql/booklet/DeletePersonalisedFile.gql";
import UPDATE_PERSONALISED_FILE from "../../graphql/booklet/UpdatePersonalisedFile.gql";
import { cloneDeep } from "@apollo/client/utilities";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";
import { Watch } from "vue-facing-decorator";
import { getImportFilesMillesim } from "../../../../backend/src/common/bundle/BundleBase";

@Component({
    components: {
        draggable,
        UploadDocuments,
    },
    emits: ["booklet-changed"],
})
export class BookletContent extends Vue {
    @Prop({ default: null }) initialBooklet: any;
    @Prop({ default: false }) readonly_: boolean;
    // @Prop({ default: null }) _initialAccForms: any;
    @Prop({ default: false }) previewMode: boolean;
    @Prop({ default: null }) bookletTemplateId: String;
    @Prop({ default: null }) bundleType: string;
    @Prop({ default: null }) booklet: any;
    @Prop({ default: null }) importFilesMillesimfromBundle: string;

    search = "";

    accountingFormCategory = "";

    accountingFormCategories = [
        { category: "custom", name: "Présentation" },
        { category: "operatingAccount", name: "Tableaux" },
        { category: "declaration", name: "Liasse" },
        { category: "annex", name: "Annexes" },
        { category: "personalisedDocument", name: "Documents importés" },
    ];

    //@VModel({ required: true })
    //booklet: any

    personalisedDocumentsDialog = false;
    persoDocToUpdate = null;
    newName = "";
    newNameLoading = false;
    persoDocToDelete = null;
    deleteLoading = false;
    customBookletTemplateDialog = false;

    actions = {
        action: new DialogAction(),
    };

    get accountingCompanyId() {
        return this.$store.state.user.company.id;
    }

    get currentUser(): User {
        return this.$store.state.user;
    }

    get searchedPages() {
        if (!this.search) {
            return this.accountingFormsPages;
        } else {
            return this.accountingFormsPages.filter((page) =>
                page.title.toLowerCase().includes(this.search.toLowerCase()),
            );
        }
    }

    get readonly() {
        if (this.readonly_ || this.previewMode) {
            return true;
        }
        return false;
    }

    get bookletContentCardStyle() {
        if (this.previewMode) {
            return "height: calc(100vh - 185px)";
        }
        return "height: calc(100vh - 180px)";
    }

    get heightOfBookletView() {
        if (this.previewMode) {
            return "height: calc(100vh - 250px); overflow-y: auto";
        }
        return "height: calc(100vh - 280px); overflow-y: auto";
    }

    get importFilesMillesim(): string {
        return getImportFilesMillesim(this.importFilesMillesimfromBundle);
    }

    formFiles: { [key: string]: { [key: string]: any } } = {
        "2024": {
            BNC: FORM_BNC_2024,
            RS_IS: FORM_RSS_2024,
            RS_IR: FORM_RSP_2024,
            RN_IS: FORM_RNS_2024,
            RN_IR: FORM_RNP_2024,
            RF: FORM_SCI_2024,
        },
        "2025": {
            BNC: FORM_BNC_2025,
            RS_IS: FORM_RSS_2025,
            RS_IR: FORM_RSP_2025,
            RN_IS: FORM_RNS_2025,
            RN_IR: FORM_RNP_2025,
            RF: FORM_SCI_2025,
            RNA: FORM_RNA_2025,
            RSA: FORM_RSA_2025,
        },
    };

    get bundleForms() {
        if (!this.bundleType) {
            return null;
        }
        return this.formFiles[this.importFilesMillesim]?.[this.bundleType] || null;
    }

    @Watch("booklet", { deep: true })
    emitContent() {
        this.$emit("booklet-changed", { booklet: this.booklet });
    }

    onDuplicatedBookletChanged() {
        this.$emit("booklet-changed", { booklet: this.duplicatedBooklet });
    }

    async addPersonalisedDoc(eventData = null) {
        if (eventData?.file?.fileKey) {
            this.actions.action.loading = true;

            this.$emit("booklet-changed", { booklet: this.booklet, file: eventData.file });

            this.actions.action.loading = false;
            this.personalisedDocumentsDialog = false;
        }
        return;
    }

    mounted() {
        // this.booklet = JSON.parse(JSON.stringify(this.booklet))
        this.accountingFormsPages = this.generateDefaultAccFormsPages();
        this.accountingFormCategory = this.accountingFormCategories[0].category;

        // initialize this.accountingForms => disable pages already used
        if (!this.previewMode && this.accountingFormsPages?.length) {
            for (const page of this.booklet.pages) {
                const pAF = this.accountingFormsPages.find((e) => e.cerfa === page.cerfa);
                if (pAF?.cerfa) {
                    if (pAF.disabled) {
                        pAF.bothFormatUsed = true;
                    }
                    pAF.disabled = true;
                }
                if (pAF?.cerfa === "03") {
                    // 'Page de séparation' can be added as much as wanted
                    pAF.disabled = false;
                }
            }
        }
    }

    getAccountingFormClass(disabled) {
        return {
            "list-group-item": true,
            item: true,
            "mt-1": true,
            "oss-list-item": true,
            "oss-disabled": disabled,
        };
    }

    getAccountingFormClassForUploadFile() {
        const result = this.getAccountingFormClass(false);
        result["d-flex"] = true;
        result["justify-center"] = true;
        result["py-2"] = true;
        return result;
    }

    getPersonalisedDocAdded() {
        const result = [];
        if (!this.initialBooklet?.files) {
            if (this.booklet?.files?.length) {
                for (const f of this.booklet.files) {
                    result.push({
                        cerfa: f.id,
                        title: f.name,
                    });
                }
            }
            return result;
        }
        for (const f of this.initialBooklet.files) {
            result.push({
                cerfa: f.id,
                title: f.name,
            });
        }
        return result;
    }

    isDraggable(item) {
        // if (item?.cerfa !== "0") {
        return "handle";
        // }
        return "";
    }

    accountingFormsPages: any[] = [];

    @Watch("bundleType")
    @Watch("booklet.files", { deep: true })
    updateListForms() {
        this.accountingFormsPages = this.generateDefaultAccFormsPages();
    }

    generateDefaultAccFormsPages() {
        if (this.bundleForms) {
            const result = this.defaultAccFormsPages;
            const declarations = JSON.parse(JSON.stringify(this.bundleForms));
            declarations.forEach(
                (d) => ((d.category = "declaration"), (d.format = "cerfa"), (d.disabled = false)),
            );
            const annexesPages = JSON.parse(JSON.stringify(BOOKLET_ANNEXES));
            annexesPages.forEach((aP) => ((aP.category = "annex"), (aP.disabled = false)));
            const personalisedDocAdded = this.getPersonalisedDocAdded();
            personalisedDocAdded.forEach(
                (pDA) => ((pDA.category = "personalisedDocument"), (pDA.disabled = false)),
            );
            return result.concat(declarations, annexesPages, personalisedDocAdded);
        }
    }

    // @Emit('change')
    async updateBooklet(item) {
        if (item?.added?.element && item?.added?.newIndex !== undefined) {
            // this.booklet = cloneDeep(this.booklet) //! if not error with draggable and printableTitles
            this.booklet.pages[item.added.newIndex] = JSON.parse(
                JSON.stringify(item.added.element),
            );

            const movedAccountingForm = this.accountingFormsPages.find(
                (e) => e.cerfa === item.added.element.cerfa,
            );
            if (movedAccountingForm?.cerfa) {
                if (movedAccountingForm.cerfa !== "03") {
                    // 'Page de séparation' can be added as much as wanted
                    movedAccountingForm.disabled = true;
                }
            }
        }
        //! then, if PageDeGarde not at first position we put it at the beginning
        // const oldIndex = this.booklet.pages.findIndex((e) => e.cerfa === "0");
        // if (oldIndex !== -1) {
        //     this.booklet.pages.unshift(this.booklet.pages.splice(oldIndex, 1)[0]);
        // }
        return;
    }

    // @Emit('change')
    addIntoBooklet(item, itemIndex) {
        debugger;
        if (this.booklet) {
            if (!this.booklet.pages) {
                debugger;
                this.booklet.pages = [];
            }
            // if (item?.cerfa === "0") {
            //     // 'Page de garde' always added at the beginning
            //     this.booklet.pages.unshift(JSON.parse(JSON.stringify(item)));
            // } else {
            this.booklet.pages.push(JSON.parse(JSON.stringify(item)));
            // }
        } else {
            debugger;
        }
        if (item?.cerfa === "03") {
            return; /* 'Page de séparation' can be added as much as wanted */
        }
        this.accountingFormsPages[itemIndex].disabled = true;
        return;
    }

    // @Emit('change')
    addDifferentFormat(item, itemIndex) {
        const newFormat = this.newFormat(item);
        const itemCopy = JSON.parse(JSON.stringify(item));
        itemCopy.format = newFormat;
        this.booklet.pages.push(itemCopy);
        this.accountingFormsPages[itemIndex].bothFormatUsed = true;
        return;
    }

    // @Emit('change')
    removeFromBooklet(item, itemIndex) {
        this.booklet.pages.splice(itemIndex, 1);
        const accountingForms_item = this.accountingFormsPages.find((e) => e.cerfa === item.cerfa);
        if (accountingForms_item.bothFormatUsed) {
            accountingForms_item.bothFormatUsed = false;
        } else {
            accountingForms_item.disabled = false;
        }
        return;
    }

    openUploadFileDialog() {
        // this.dialogStep = 'chooseDocType'
        this.actions.action.display = false;
        this.actions.action.loading = false;
        this.personalisedDocumentsDialog = true;
    }

    // @Emit('change')
    async deletePersonalisedDoc() {
        this.deleteLoading = true;
        const indexBookletToDelete = this.booklet.pages.findIndex(
            (e) => e.cerfa === this.persoDocToDelete,
        );
        if (
            indexBookletToDelete &&
            indexBookletToDelete !== -1 &&
            this.booklet.pages[indexBookletToDelete]?.category === "personalisedDocument"
        ) {
            this.booklet.pages.splice(indexBookletToDelete, 1);
        }
        const indexPageToDelete = this.accountingFormsPages.findIndex(
            (e) => e.cerfa === this.persoDocToDelete,
        );
        if (
            indexPageToDelete &&
            indexPageToDelete !== -1 &&
            this.accountingFormsPages[indexPageToDelete]?.category === "personalisedDocument"
        ) {
            this.accountingFormsPages.splice(indexPageToDelete, 1);
            await this.$apollo.mutate({
                mutation: DELETE_PERSONALISED_FILE,
                variables: {
                    id: this.persoDocToDelete,
                },
            });

            const index = this.booklet.files.findIndex((e) => e.id === this.persoDocToDelete);
            if (index !== -1) {
                this.booklet.files.splice(index, 1);
            }
            const index2 = this.booklet.pages.findIndex((e) => e.cerfa === this.persoDocToDelete);
            if (index2 !== -1) {
                this.booklet.pages.splice(index2, 1);
            }
        }
        this.deleteLoading = false;
        this.persoDocToDelete = null;
        return;
    }

    async updatePersonalisedDocName(cerfa, newName) {
        this.newNameLoading = true;
        if (!newName) {
            return;
        }
        const bookletPageToUpdate = this.booklet.pages.find((e) => e.cerfa === cerfa);
        if (bookletPageToUpdate && bookletPageToUpdate.category === "personalisedDocument") {
            bookletPageToUpdate.title = newName;
        }
        const pageToUpdate = this.accountingFormsPages.find((e) => e.cerfa === cerfa);
        if (pageToUpdate && pageToUpdate.category === "personalisedDocument") {
            pageToUpdate.title = newName;
            await this.$apollo.mutate({
                mutation: UPDATE_PERSONALISED_FILE,
                variables: {
                    id: cerfa,
                    newName: newName,
                },
            });
        }
        this.newNameLoading = false;
        this.newName = "";
        this.persoDocToUpdate = null;
    }

    isInBooklet(item) {
        if (this.booklet.pages.findIndex((e) => e.cerfa === item.cerfa) !== -1) {
            return true;
        }
        return false;
    }

    newFormat(item) {
        const otherFormat = this.booklet.pages.find((e) => e.cerfa === item.cerfa).format;
        return otherFormat === "saisie" ? "cerfa" : "saisie";
    }

    changeFormat(item) {
        const oldFormat = item.format === "saisie" ? "cerfa" : "saisie"; // because format changement already finished
        const otherItemSameCerfa = this.booklet.pages.find(
            (e) => e.cerfa === item.cerfa && e !== item,
        );
        if (otherItemSameCerfa) {
            otherItemSameCerfa.format = oldFormat;
        }
    }

    displayTitle(page) {
        if (page.category === "declaration") {
            return page.cerfa + ": " + page.title;
        }
        return page.title;
    }

    displayPageFormat(format) {
        if (format) {
            if (format === "cerfa") {
                return "Format CERFA";
            } else if (format === "saisie") {
                return "Format 'saisie'";
            }
        }
        return "";
    }

    defaultAccFormsPages = [
        { cerfa: "0", title: "Page de garde", category: "custom", disabled: false }, //! always at the firstPage or export won't work
        { cerfa: "01", title: "Sommaire", category: "custom", disabled: false }, //A venir dans bobbee
        {
            cerfa: "02",
            title: "Attestation de l'Expert-Comptable",
            category: "custom",
            disabled: false,
        },
        {
            cerfa: "03",
            title: "Page de séparation",
            category: "custom",
            disabled: false,
            printableTitle: "",
        },
        {
            cerfa: "04",
            title: "Page de séparation",
            category: "custom",
            disabled: false,
            printableTitle: "Comptes annuels",
        },
        {
            cerfa: "05",
            title: "Page de séparation",
            category: "custom",
            disabled: false,
            printableTitle: "Liasse fiscale",
        },
        {
            cerfa: "06",
            title: "Page de séparation",
            category: "custom",
            disabled: false,
            printableTitle: "Annexes",
        },

        { cerfa: "#BalanceSheet", title: "Bilan", category: "operatingAccount", disabled: false },
        {
            cerfa: "#BalanceSheetDetailed",
            title: "Bilan détaillé",
            category: "operatingAccount",
            disabled: false,
        },
        {
            cerfa: "#IncomeStatement",
            title: "Compte de résultat",
            category: "operatingAccount",
            disabled: false,
        },
        {
            cerfa: "#IncomeStatementDetailed",
            title: "Compte de résultat détaillé",
            category: "operatingAccount",
            disabled: false,
        },
        { cerfa: "#SIG", title: "SIG", category: "operatingAccount", disabled: false },
        {
            cerfa: "#SIGDetailed",
            title: "SIG détaillés",
            category: "operatingAccount",
            disabled: false,
        },
    ];

    duplicatedBooklet = null;

    openCustomDialog() {
        this.duplicatedBooklet = cloneDeep(this.booklet);
        this.customBookletTemplateDialog = true;
    }
}

export default toNative(BookletContent);
</script>

<style lang="scss">
.separationPageTextField {
    font-size: x-small;
}
</style>
